import * as ko from 'knockout'
import { MultiSelectionPriceViewModel, Params } from './MultiSelectionPriceViewModel'
import template from './multselection.pricing.tpl.html'

if (!ko.components.isRegistered('multiselection-pricing')) {
  ko.components.register('multiselection-pricing', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new MultiSelectionPriceViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
